<template>
    <div class="card" v-bind:class="{['variant-'+variant]: variant}" v-else>
        <div class="card-inner">
            <div v-if="cardTitle" class="card-title">
                <h2 class="headline-2 card-title-text">{{cardTitle}}</h2>
                <div class="card-title-actions">
                    <!-- @slot Top card actions -->
                    <slot name="card-actions" class="card-title-actions">
                    </slot>
                </div>
            </div>
            <div class="card-content" v-bind:class="{['padding-'+contentSpacing]: contentSpacing}">
                <!-- @slot For general contents -->
                <slot ></slot>
                <!-- @slot Bottom card actions -->
                <slot name="card-bottom-actions" class="card-bottom-actions"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    import Button from "../../components/Button/Button";

    export default {
        name: 'Card',
        components: {
            Button
        },
        props: {
            cardTitle: {
                type: String
            },
            cardTitleComponent: {
                type: String
            },
            contentSpacing: {
                type: String,
                default: 'default'
            },
            variant: {
                type: String,
                default: 'default'
            }
        },
        data () {
            return {
            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Card.scss" scoped lang="scss"></style>

